import apiClient from './api/client';
import { ENDPOINTS } from './api/endpoints';

export const notificationDeliveryService = {
  getAll: (params) =>
    apiClient.get(ENDPOINTS.NOTIFICATION_DELIVERIES.GET_ALL, { params }),
  getById: (id) =>
    apiClient.get(ENDPOINTS.NOTIFICATION_DELIVERIES.GET_BY_ID(id)),
  getStats: (params) =>
    apiClient.get(ENDPOINTS.NOTIFICATION_DELIVERIES.GET_STATS, { params }),
  resend: (id) =>
    apiClient.post(ENDPOINTS.NOTIFICATION_DELIVERIES.RESEND(id)),
};
